var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewuserweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#10B981",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_27163)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2074_27163",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H31V31H11V11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2074_27163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 19.5H28.5V17.5C28.5 17.225 28.275 17 28 17H27C26.725 17 26.5 17.225 26.5 17.5V19.5H24.5C24.225 19.5 24 19.725 24 20V21C24 21.275 24.225 21.5 24.5 21.5H26.5V23.5C26.5 23.775 26.725 24 27 24H28C28.275 24 28.5 23.775 28.5 23.5V21.5H30.5C30.775 21.5 31 21.275 31 21V20C31 19.725 30.775 19.5 30.5 19.5ZM18 21C20.2094 21 22 19.2094 22 17C22 14.7906 20.2094 13 18 13C15.7906 13 14 14.7906 14 17C14 19.2094 15.7906 21 18 21ZM20.8 22H20.2781C19.5844 22.3188 18.8125 22.5 18 22.5C17.1875 22.5 16.4187 22.3188 15.7219 22H15.2C12.8812 22 11 23.8813 11 26.2V27.5C11 28.3281 11.6719 29 12.5 29H23.5C24.3281 29 25 28.3281 25 27.5V26.2C25 23.8813 23.1187 22 20.8 22Z",
    fill: "#10B981"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_27163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewuserweb);
export default __webpack_public_path__ + "static/media/newuserweb.7949499c91b021c39921a6affb6a0e6d.svg";
export { ForwardRef as ReactComponent };